import client from '../client'

// 어린이 시사사전 API 상세보기 호출
export default async function getWoonginDetail(searchWordNo: string, requestApi: string) {
  const response = await client.post<any>(`/api/search`, {
    searchWordNo: searchWordNo,
    requestApi: requestApi, // [wjpediaDetailSearchUri, stKorDictSenseUri, stKorDictUri, senseDetailSearchUri]
  })

  // 좀 복잡해서 그냥 복붙함
  if (response.data.hasOwnProperty('result')) {
    var resultObjectMap = response.data.result.map
    if (resultObjectMap.hasOwnProperty('RESP_RESULT')) {
      return resultObjectMap.RESP_RESULT.map
    }
  }

  return response.data
}
